export default "query getDettaglioStoricoUpload ($id: Int!) {\n    getDettaglioStoricoUpload(id: $id)\n}";